import React, { Component } from 'react';
import { CSSTransition } from 'react-transition-group';

// import IconChevron from '../atoms/IconChevron';

class IntroButton extends Component {

  handleCloseClick = () => {
    this.props.handleCloseClick();
  };

  handleProgressClick = () => {
    this.props.handleProgressClick();
  };

  render() {
    return (
      <>
        <CSSTransition
          in={true}
          // in={this.props.step === 1}
          unmountOnExit
          classNames="IntroButton"
          timeout={1500}>
          <button
            className="IntroButton secondary"
            type="button"
            // onClick={this.handleProgressClick}
            onClick={this.handleCloseClick}
          >
            Start Exploring
          </button>
        </CSSTransition>

        {/* <CSSTransition
          in={this.props.step === 4}
          unmountOnExit
          classNames="IntroButton"
          timeout={1500}>
          <button className="IntroButton secondary" type="button" onClick={this.handleCloseClick}>Discover your
            connection
          </button>
        </CSSTransition>

        <CSSTransition
          in={this.props.step === 2 || this.props.step === 3}
          unmountOnExit
          classNames="IntroButton"
          timeout={1500}>
          <button className="IntroButton iconButton" type="button" onClick={this.handleProgressClick}><IconChevron/>
          </button>
        </CSSTransition> */}
      </>

    )

  }
}

export default IntroButton;